<template>
	<div class="content-button">
		<div :class="`button-text ${isApproval ? 'button-active': 'button-unactive'} `" @click="$emit('approve')">
			<v-icon v-if="$vuetify.breakpoint.mdAndUp && !approveLoading" small color="white" class="mr-1">mdi-check</v-icon>
			<v-progress-circular v-if="$vuetify.breakpoint.mdAndUp && approveLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#FFFFFF`" indeterminate></v-progress-circular>
			Approve
		</div>
		<div :class="`button-text button-default-text ml-2 ${isMoreInfo ? 'button-default-able':'button-default-unable'}`" @click="$emit('more-info')">
			<v-progress-circular v-if="$vuetify.breakpoint.mdAndUp && rejectLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
			<span>Reject</span>
		</div>
		<div :class="`button-text ${isForward ? 'button-default-able':'button-default-unable'} ml-2`" @click="$emit('forward')">
			<v-progress-circular v-if="$vuetify.breakpoint.mdAndUp && forwardLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
			<span>Forward</span>
		</div>
		<div v-if="$vuetify.breakpoint.mdAndUp" class="button-text ml-2" :class="isDelete ? 'button-default-able':'button-default-unable'" @click="onDelete()">
			<v-progress-circular v-if="$vuetify.breakpoint.mdAndUp && deleteLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
			Delete
		</div>
		<div v-if="$vuetify.breakpoint.mdAndUp && claimId === 0" class="button-text button-default-able ml-2" @click="$emit('print')">
			<v-progress-circular v-if="$vuetify.breakpoint.mdAndUp && printLoading" class="mr-1" :width="2" :size="16" :value="20" :color="`#2196F3`" indeterminate></v-progress-circular>
			Print
		</div>
	</div>
</template>
<script>
export default {
	name: 'ApprovalButton',
	props: {
		isApproval: {
			type: Boolean,
			default: true
		},
		isMoreInfo: {
			type: Boolean,
			default: true
		},
		isForward: {
			type: Boolean,
			default: true
		},
		isDelete: {
			type: Boolean,
			default: true
		},
		approveLoading: {
			type: Boolean,
			default: false
		},
		rejectLoading: {
			type: Boolean,
			default: false
		},
		forwardLoading: {
			type: Boolean,
			default: false
		},
		deleteLoading: {
			type: Boolean,
			default: false
		},
		printLoading: {
			type: Boolean,
			default: false
		},
		claimId: {
			type: Number,
			default: 0
		}
	},
	methods: {
		onDelete() {
			if (this.isDelete) {
				this.$emit('delete');
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.content-button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}
.button-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 36px;
  padding: 0 12px;
  border-radius: 4px;
}
.button-active {
  background: #00AAFD;
  color: #FFFFFF;
  &:hover {
    cursor: pointer;
  }
}
.button-unactive {
  background: rgba(25, 42, 62, 0.15);
  color: #FFFFFF;
}
.button-default-able {
  border: 1px solid #00AAFD;
  color: #00AAFD;
  &:hover {
    cursor: pointer;
  }
}
.button-default-unable {
  border: 1px solid rgba(25, 42, 62, 0.3);
  color: rgba(25, 42, 62, 0.3);
}

</style>